import { render, staticRenderFns } from "./LogoLoader.vue?vue&type=template&id=5957ea01"
import script from "./LogoLoader.vue?vue&type=script&lang=js"
export * from "./LogoLoader.vue?vue&type=script&lang=js"
import style0 from "./LogoLoader.vue?vue&type=style&index=0&id=5957ea01&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports